import React from 'react'
import { Row, Col, Container } from 'react-bootstrap'
import imgT1 from '../../assets/image/inner/team-image-1.png'
import imgT2 from '../../assets/image/inner/team-image-2.png'
import imgT3 from '../../assets/image/inner/team-image-3.png'
import imgT4 from '../../assets/image/inner/team-image-4.png'
import imgT5 from '../../assets/image/inner/team-image-5.png'
import imgT6 from '../../assets/image/inner/team-image-6.png'
import imgT7 from '../../assets/image/inner/team-image-7.png'

const Alternative = () => {
    return (

        <>
            <Col xs="12">
                <div className="px-md-12 text-center mb-11 mb-lg-14" >
                    <div className="pt-13 pb-lg-24 ">
                        <Container>
                            <Row className="justify-content-left mb-lg-n15 mb-0">
                                <Col lg="3" md="4" xs="6" className="mb-lg-15 mb-13">
                                    <div className="team-card">
                                        <div className="card-image">
                                            <img src={imgT1} alt="" className="w-100" />
                                        </div>
                                        <div className="card-text pt-9">
                                            <h3 className="gr-text-7 mb-2">Jeffrey Walters</h3>
                                            <p className="gr-text-9 mb-0 line-height-1">
                                                Cheif Executive Officer
                                            </p>
                                            <div className="">
                                                <a
                                                    href="/#"
                                                    className="btn-link with-icon gr-text-blue gr-text-7 font-weight-bold mt-5"
                                                >
                                                    <i className="icon icon-tail-right font-weight-bold"></i>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </Col>
                                <Col lg="3" md="4" xs="6" className="mb-lg-15 mb-13">
                                    <div className="team-card">
                                        <div className="card-image">
                                            <img src={imgT2} alt="" className="w-100" />
                                        </div>
                                        <div className="card-text pt-9">
                                            <h3 className="gr-text-7 mb-2">Jeffrey Walters</h3>
                                            <p className="gr-text-9 mb-0 line-height-1">
                                                Chief Executive Officer
                                            </p>
                                            <div className="">
                                                <a
                                                    href="/#"
                                                    className="btn-link with-icon gr-text-blue gr-text-7 font-weight-bold mt-5"
                                                >
                                                    <i className="icon icon-tail-right font-weight-bold"></i>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </Col>
                                <Col lg="3" md="4" xs="6" className="mb-lg-15 mb-13">
                                    <div className="team-card">
                                        <div className="card-image">
                                            <img src={imgT3} alt="" className="w-100" />
                                        </div>
                                        <div className="card-text pt-9">
                                            <h3 className="gr-text-7 mb-2">Jason Reed</h3>
                                            <p className="gr-text-9 mb-0 line-height-1">
                                                Chief Technology Officer
                                            </p>
                                            <div className="">
                                                <a
                                                    href="/#"
                                                    className="btn-link with-icon gr-text-blue gr-text-7 font-weight-bold mt-5"
                                                >
                                                    <i className="icon icon-tail-right font-weight-bold"></i>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </Col>
                                <Col lg="3" md="4" xs="6" className="mb-lg-15 mb-13">
                                    <div className="team-card">
                                        <div className="card-image">
                                            <img src={imgT4} alt="" className="w-100" />
                                        </div>
                                        <div className="card-text pt-9">
                                            <h3 className="gr-text-7 mb-2">Nellie Padilla</h3>
                                            <p className="gr-text-9 mb-0 line-height-1">
                                                Creative Director
                                            </p>
                                            <div className="">
                                                <a
                                                    href="/#"
                                                    className="btn-link with-icon gr-text-blue gr-text-7 font-weight-bold mt-5"
                                                >
                                                    <i className="icon icon-tail-right font-weight-bold"></i>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </Col>
                                <Col lg="3" md="4" xs="6" className="mb-lg-15 mb-13 text-center">
                                    <div className="team-card">
                                        <div className="card-image">
                                            <img src={imgT5} alt="" className="w-100" />
                                        </div>
                                        <div className="card-text pt-9">
                                            <h3 className="gr-text-7 mb-2">Dean Bell</h3>
                                            <p className="gr-text-9 mb-0 line-height-1">
                                                Lead Programmer
                                            </p>
                                            <div className="">
                                                <a
                                                    href="/#"
                                                    className="btn-link with-icon gr-text-blue gr-text-7 font-weight-bold mt-5"
                                                >
                                                    <i className="icon icon-tail-right font-weight-bold"></i>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                        </Container>
                    </div>
                </div>
            </Col>
        </>
    )
    }
    

export default Alternative